import { operationsStatusEnumList } from '../../../components/AgGrid/enumLists'

const operationsStatusValueGetter = (props) => {
  const { value } = props
  return operationsStatusEnumList(value)
}

export default operationsStatusValueGetter
